import { io } from 'socket.io-client';
import { baseUrl } from '../../../shared';

export const messagingSocket = io(baseUrl + 'api/gateway', {withCredentials: true, transports: ['websocket']});